/**
 * Resolve a stable offline storage seat id for the logged-in partner session.
 * Uses JWT claims so owner vs team seats do not collide in IndexedDB.
 */
export function getPartnerSessionFromToken() {
  try {
    const token = localStorage.getItem('partnerToken');
    if (!token) {
      return { isPartnerUser: false, partnerUserId: null, partnerId: null };
    }
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      isPartnerUser: payload.type === 'partner_user',
      partnerUserId: payload.partnerUserId || null,
      partnerId: payload.partnerId || payload.id || null,
    };
  } catch {
    return { isPartnerUser: false, partnerUserId: null, partnerId: null };
  }
}

export function getPartnerOfflineSeatId() {
  try {
    const token = localStorage.getItem('partnerToken');
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.partnerUserId) {
      return `partnerUser:${payload.partnerUserId}`;
    }
    const partnerId = payload.partnerId || payload.id;
    if (partnerId) return `partner:${partnerId}`;
    return null;
  } catch {
    return null;
  }
}

/**
 * Best-effort device registration for partner push.
 * Uses Appilix bridge when present, or localStorage partnerPushToken for QA.
 */
export async function tryRegisterPartnerPushDevice(api) {
  const authToken = localStorage.getItem('partnerToken');
  if (!authToken || !api) return { registered: false };

  let deviceToken = null;
  let platform = 'web';

  try {
    const bridge = typeof window !== 'undefined'
      ? (window.Appilix || window.ApplixApp || null)
      : null;
    if (bridge?.getFCMToken) {
      deviceToken = await bridge.getFCMToken();
    } else if (bridge?.getPushToken) {
      deviceToken = await bridge.getPushToken();
    }
  } catch (err) {
    console.warn('Partner push token from bridge failed:', err?.message || err);
  }

  if (!deviceToken) {
    deviceToken = localStorage.getItem('partnerPushToken');
  }

  if (!deviceToken) {
    return { registered: false, reason: 'no_token' };
  }

  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  if (/iPhone|iPad|iPod/i.test(ua)) platform = 'ios';
  else if (/Android/i.test(ua)) platform = 'android';

  try {
    await api.post(
      '/partners/register-device',
      { token: deviceToken, platform },
      { usePartnerAuth: true }
    );
    return { registered: true, platform };
  } catch (err) {
    console.warn('Partner push register failed:', err?.response?.data || err?.message);
    return { registered: false, reason: 'request_failed' };
  }
}
